import { render } from "./App.vue?vue&type=template&id=6d81a9c9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "swiper/swiper-bundle.css?vue&type=style&index=0&lang=css"
import "@/assets/css/app.css?vue&type=style&index=1&lang=css"
import "./App.vue?vue&type=style&index=2&id=6d81a9c9&lang=postcss"
script.render = render

export default script